<template>
  <div class="wrapper">
    <div class="title">
      <img src="https://www.servicefun.cn/static/img/landingpageQwb.png" alt=""  />
    </div>
    <div class="discription">
      <div>选最实用的服务保障产品，更省更放心</div>
      <div>旗舰版手机畅享多项权益</div>
      <div>碎屏、后盖、电池、延长保修、补差换新</div>
    </div>
    <div class="mid-discription">
      <img src="https://www.servicefun.cn/static/img/text-1.png" alt="" />
      <img src="https://www.servicefun.cn/static/img/text-2.png" alt="" />
      <img src="https://www.servicefun.cn/static/img/text-3.png" alt="" />
    </div>
    <div class="button-wrapper">
      <van-button class="btn" @click="$router.push('/')" type="danger"
        >
        <img src="https://www.servicefun.cn/static/img/icon-2.png" alt="">
        激活服务卡</van-button
      >
      <van-button
        class="btn"
        @click="$router.push('/searchCode')"
        type="danger"
        style="margin-top: 10px"
        >
        <img src="https://www.servicefun.cn/static/img/icon-1.png" alt="">
        查询服务卡</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "landingpage3",
};
</script>

<style lang="less" scoped>
.wrapper {
  background: url(https://www.servicefun.cn/static/img/langding-bg.png)
    no-repeat;
  height: 100%;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;

  .title {
    margin-top: 25px;
    margin-left: 12px;
    img {
      width: 151px;
      // height: 50px;
    }
  }
  .discription {
    width: 335px;
    height: 89px;
    border-radius: 7px;
    margin-top: 24px;
    align-self: center;
    background: url(https://www.servicefun.cn/static/img/49.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    div {
      font-weight: 400;
      color: #fff;
      font-size: 13px;
      line-height: 20px;
    }
  }
  .mid-discription {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 110px;
    height: 120px;
    img{
       width: 76px;
       height: 22px;
    }
  }
  .button-wrapper {
    display: flex;
    margin-top: 130px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    .btn {
      width: 200px;
      height: 59px;
      background: url(https://www.servicefun.cn/static/img/btn-bg.png) no-repeat;
      background-size: 100% 100%;
      border: none;
      font-size: 16px;
    }
    /deep/ .van-button__text{
        display: flex;
        align-items: center;
        justify-content: center;
        img{
            margin-right: 2px;
        }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/landingpage3/index.vue